import React from 'react';
const modules = [{
  num: '1',
  title: 'Yoga Foundations',
  description: 'The solid base for confident, safe teaching.'
}, {
  num: '2',
  title: 'Pose Library',
  description: 'Your complete encyclopedia of 80 essential poses.'
}, {
  num: '3',
  title: 'Class Builder System',
  description: 'Ready-to-use planning framework for any format.'
}, {
  num: '4',
  title: 'Professional Sequences',
  description: '70 complete classes ready to teach today.'
}, {
  num: '5',
  title: 'Student Progression System',
  description: 'Guide every student through real results.'
}, {
  num: '6',
  title: 'Teaching Mastery',
  description: 'The tools to teach with authority and presence.'
}];
export function TomiSection() {
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-178">
      <div className="max-w-4xl mx-auto" data-id="element-179">
        <div className="text-center mb-6" data-id="element-180">
          <h2 className="text-2xl sm:text-3xl font-serif font-extrabold text-brand-graphite mb-1 uppercase leading-tight" data-id="element-181">
            THE SOLUTION YOU'VE BEEN WAITING FOR — A 6-IN-1 SYSTEM
          </h2>
          <p className="text-base font-bold text-brand-rose mb-3" data-id="element-182">
            6 guides in 1, designed for movement professionals
          </p>
          <div className="inline-block bg-brand-petrol text-white px-4 py-1.5 rounded-md mb-3 shadow-md" data-id="element-183">
            <p className="font-bold text-sm sm:text-base tracking-wide" data-id="element-184">
              Yoga Ready 6-in-1 Box Set
            </p>
          </div>
          <p className="text-base text-brand-graphite/90 font-medium max-w-3xl mx-auto leading-snug" data-id="element-185">
            YOGA READY™ is much more than a simple manual. It is a complete
            operating system that delivers professional sessions, pedagogically
            structured to guarantee flow and authority in the studio.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-186">
          {modules.map((module, i) => <div key={i} className="bg-white border-2 border-brand-gold/40 p-3 rounded-lg flex gap-3 items-center shadow-sm hover:border-brand-petrol transition-colors" data-id="element-187">
              <div className="bg-brand-petrol text-white font-bold px-3 py-1.5 rounded text-xs shrink-0 tracking-wider" data-id="element-188">
                GUIDE {module.num}
              </div>
              <div data-id="element-189">
                <h3 className="text-sm sm:text-base font-bold text-brand-graphite leading-tight" data-id="element-190">
                  {module.title}
                </h3>
                <p className="text-brand-graphite/70 text-xs sm:text-sm font-medium mt-0.5" data-id="element-191">
                  {module.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}